import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'f3date',
    pure: false,
    standalone: false
})
export class F3DatePipe implements PipeTransform {


	private daysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    private daysLong = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
    private monthsShort= ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	private monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


    transform(value: Date | string, format: string = 'shortdate'): string {

		value = value.toString().replace(/-/g, "/")
        const date = new Date(value)

        let retValue ='';
        switch(format) {
            case 'shortDate' : 
                retValue = this._shortdate(date);
                break;
            case 'shortDateTime' :
                retValue = this._shortdate_time(date);
                break;
			case 'mediumDate' :
				retValue = this._mediumdate(date, false);
				break;
			case 'mediumDateWithDay' : 
				retValue = this._mediumdate(date, true);
				break;
			case 'longDateWithDay' :
				retValue = this._longdate(date, true);
				break;
			case 'longDateTimeWithDay' :
				retValue = this._longdatetime(date, true);
				break;
			case '12HourTimeWithMeridiem' : 
				retValue = this._time(date, true, true);
				break;
			case 'dayOfWeekShort' : 
				retValue = this.daysShort[date.getDay()];
				break;
			case 'dayOfWeekLong' :
				retValue = this.daysLong[date.getDay()];
				break;
            default : 
                retValue = '';
                break;
        }

        return retValue;
    }



    private _shortdate(date: Date): string {
		return this._padValue(date.getDate()) + '/' + this._padValue(date.getMonth() + 1) + '/' + date.getFullYear()
    }

    private _shortdate_time(date: Date) : string {
        return this._shortdate(date) + ' ' + this._time(date, true, true);
    }

	private _mediumdate(date: Date, withDay: boolean = false): string {
		let retValue = '';

		if(withDay) retValue += this.daysShort[date.getDay()] + ', ';

		retValue += date.getDate() + this._getDateSuffix(date.getDate()) + ' ' + this.monthsShort[date.getMonth()] + ' ' + date.getFullYear();

		return retValue;
	}

	private _longdate(date: Date, withDay: boolean = false): string {
		let retValue = '';
		if(withDay) {
			retValue += this.daysLong[date.getDay()] + ', '
		}

		retValue += date.getDate() + this._getDateSuffix(date.getDate()) + ' ' + this.monthsFull[date.getMonth()] + ' ' + date.getFullYear();

		return retValue;
	}


	private _longdatetime(date: Date, withDay: boolean = false) {
		let retValue = '';
		
		if(withDay) retValue += this._longdate(date, true)

		retValue += ' ' + this._time(date, true, true)

		return retValue
	}


	private _time(date: Date, twelveHour: boolean = true, meridiem: boolean = false): string {
		date = new Date(date);

		let retValue = '';

		let hours = date.getHours()

		if(twelveHour) hours = hours > 12 ? hours - 12 : hours;

		retValue += hours + ':' + this._padValue(date.getMinutes());

		if(meridiem) retValue += this._getAmPm(date.getHours()); 

		return retValue;

	}


    private _padValue(value: number): string {
        if(value < 10) {
            return '0' + value.toString();
        }

        return value.toString();
    }
	

	private _getDateSuffix(date: number) {
		let retValue = '';
		switch(date) {
			case 1	:
			case 21 : 
			case 31 :
				retValue = 'st';
				break;
			case 2 : 
			case 22 :
				retValue = 'nd';
				break;
			case 3 :
			case 23 :
				retValue = 'rd';
				break;
			default :
				retValue = 'th';
				break;
		}
		return retValue;
	}



    private _getAmPm(hours: number): string {
        return hours < 12 ? 'am' : 'pm'
    }


}